import styled from 'styled-components'

const IncompleteElementsListStyled = styled.ul`
  list-style: none;
  margin: 0;
  padding: 8px;
  overflow: visible auto;
`

export default IncompleteElementsListStyled
